import PrimaryButton from "../PrimaryButton";

/* eslint-disable @next/next/no-img-element */
export interface IMaintenanceProps {}
export default function Maintenance(props: IMaintenanceProps) {
  return <div className="w-full h-full relative" data-sentry-component="Maintenance" data-sentry-source-file="index.tsx">
      <div className="absolute inset-0 z-10 h-full w-full flex flex-col justify-between  px-4 py-8 text-[#fff]">
        <div className="flex flex-col gap-1 items-center text-start">
          <div className="flex items-center text-lg gap-1 font-semibold">
            <p className="text-[#01FFFF]">TBK</p>
            Maintenance
          </div>
          <div className="whitespace-pre-line" dangerouslySetInnerHTML={{
          __html: (process.env.NEXT_PUBLIC_MAINTENANCE_TEXT ?? "").replaceAll("TBK", '<span class="text-[#01FFFF]">TBK</span>')
        }}>
            {/* <span className="text-[#01FFFF]">TBK</span>
             {" will be undergo an upgrade " +
              process.env.NEXT_PUBLIC_MAINTENANCE_TIME +
              " for about " +
              process.env.NEXT_PUBLIC_MAINTENANCE_DURATION +
              ".\n\n Upgrade highlight:\n Faster "}
             <span className="text-[#01FFFF]">TBK</span>
             {
              " core\n Lower cost smart contract\n Enhanced statistic module\n Advanced security protocols\n\n Feature may briefly be down, but your funds and data are secure. Thanks for your patience!"
             } */}
          </div>
        </div>

        <PrimaryButton onClick={() => {
        window.location.reload();
      }} data-sentry-element="PrimaryButton" data-sentry-source-file="index.tsx">
          {"Reload Page"}
        </PrimaryButton>
      </div>
      <img src={"/images/maintenance-image.png"} alt="" className="h-[45vh] absolute -bottom-[5vh] -right-[15vw]" />
    </div>;
}